// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7ca94554","732":"6ed9c0eb","977":"eb0fcd1d"}[chunkId] + ".chunk.js";
};